import { SortInput } from 'components/Table'
import { DomainPrebidModuleSortBy } from '../../hooks/useGetPrebidModuleDomains/types'

export const DEFAULT_SORT: SortInput<DomainPrebidModuleSortBy> = {
  by: 'domain.name',
  direction: 'asc',
} as const

export const SORTABLE_COLUMNS: DomainPrebidModuleSortBy[] = ['domain.name', 'enabled', 'updatedAt']
